import React, { useState } from 'react';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { CloseAction, DmBriefCloseReason } from '../../types';
import { AppI18n } from '../../i18n';
import { CloseReasonCombobox } from './CloseReasonCombobox';
import { CLOSE_MODAL_T_PREFIX, translationKeyByCloseAction } from './constants';

export interface CloseBriefModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (closeReason?: DmBriefCloseReason) => void;
  closeAction: CloseAction;
}

export const CloseBriefModal = ({ onClose, isOpen, onConfirm, closeAction }: CloseBriefModalProps) => {
  const translations = translationKeyByCloseAction[closeAction];

  const [closeReason, setCloseReason] = useState<DmBriefCloseReason>();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent size={closeAction === CloseAction.SET_TO_INACTIVE ? 'md' : 'sm'}>
        <ModalHeader>
          <AppI18n k={`${translations}.title`} />
          <ModalCloseBtn />
        </ModalHeader>
        <ModalBody>
          <Stack direction="column" gap="8">
            <Text color="bodySecondary" whiteSpace="preWrap">
              <AppI18n k={`${translations}.description`} />
            </Text>
            {closeAction === CloseAction.SET_TO_INACTIVE && <CloseReasonCombobox setCloseReason={setCloseReason} />}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Stack justifyContent="flexEnd">
            <Button onClick={onClose} variant="ghost" intent="secondary">
              <AppI18n k={`${CLOSE_MODAL_T_PREFIX}.go_back`} />
            </Button>
            <Button
              onClick={() => onConfirm(closeReason)}
              intent="primary"
              disabled={closeAction === CloseAction.SET_TO_INACTIVE && closeReason === undefined}
            >
              <AppI18n k={`${translations}.cta`} />
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export * from './useCloseBriefModal';
export * from './CloseBriefButton';
